import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Radar({
  color = 'icon.primary',
  strokeWidth = '1',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 14 13' {...props}>
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M11.5066 5.92305C10.4367 4.63545 8.84933
         3.89062 7.1752 3.89062C5.50106 3.89062 3.91371
          4.63545 2.84375 5.92305'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M1.28906 3.89828C2.79925 2.24356 4.93607 1.30078 7.17633
         1.30078C9.41661 1.30078 11.5534 2.24356 13.0636 3.89828'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        stroke-linejoin='round'
      />
      <Path
        d='M3.83087 10.9257L6.55649 7.82266C6.7059 7.65234 6.92147 7.55469
         7.14803 7.55469C7.3746 7.55469 7.59016 7.65234 7.73957 7.82266L10.4652
          10.9257C10.6708 11.1589 10.7211 11.4908 10.5938 11.7746C10.4666
           12.0583 10.1853 12.2414 9.87447 12.2432H4.42164C4.11071 12.2414
            3.82946 12.0583 3.70225 11.7746C3.57504 11.4908 3.62532 11.1589 3.83087 10.9257Z'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        stroke-linejoin='round'
      />
    </IconBase>
  )
}

Radar.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default Radar
